document.addEventListener("DOMContentLoaded", () => {
  function updateIndicators(track) {
    const card = track.closest(".product-item__inner");
    if (!card) return;
    const indicators = card.querySelectorAll(".product-item__indicator");
    if (indicators.length === 0) return;

    const itemWidth = track.clientWidth;
    if (itemWidth === 0) return;

    const index = Math.round(track.scrollLeft / itemWidth);

    indicators.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("product-item__indicator--active");
      } else {
        dot.classList.remove("product-item__indicator--active");
      }
    });
  }

  document.addEventListener("click", (e) => {
    const arrow = e.target.closest(".product-item__arrow");
    if (!arrow) return;

    e.preventDefault();
    e.stopPropagation();
    arrow.blur(); // Remove focus to prevent sticky hover state

    const slider = arrow.closest(".product-item__media-slider");
    const track = slider.querySelector(".product-item__media-track");
    if (!track) return;

    const direction = arrow.classList.contains("product-item__arrow--next")
      ? 1
      : -1;
    const itemWidth = track.clientWidth;
    const maxScroll = track.scrollWidth - track.clientWidth;

    // Check boundaries for infinite loop
    if (direction === 1) {
      // Next
      // If close to end (within 5px tolerance), loop to start
      if (track.scrollLeft >= maxScroll - 5) {
        track.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        track.scrollBy({ left: itemWidth, behavior: "smooth" });
      }
    } else {
      // Prev
      // If close to start, loop to end
      if (track.scrollLeft <= 5) {
        track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
      } else {
        track.scrollBy({ left: -itemWidth, behavior: "smooth" });
      }
    }
  });

  // Setup scroll tracking for indicators
  const tracks = document.querySelectorAll(".product-item__media-track");
  tracks.forEach((track) => {
    // Use efficient scroll handler
    let ticking = false;
    track.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateIndicators(track);
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    // Initial update for indicators
    updateIndicators(track);
  });

  // ResizeObserver to handle initialization when visibility changes
  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        // If it has width, update indicators
        if (entry.contentRect.width > 0) {
          const track = entry.target.querySelector(
            ".product-item__media-track"
          );
          if (track) updateIndicators(track);
        }
      });
    });

    document
      .querySelectorAll(".product-item__media-slider")
      .forEach((slider) => {
        resizeObserver.observe(slider);
      });
  }
});
